export default function noneLayout({ children }) {
    return <div className="">{children}</div>;
  }